import { render, staticRenderFns } from "./SortTracks.vue?vue&type=template&id=48c57baf&scoped=true&"
import script from "./SortTracks.vue?vue&type=script&lang=js&"
export * from "./SortTracks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48c57baf",
  null
  
)

export default component.exports